__turbopack_context__.v({
  "inlineLink": "IAjEnG_inlineLink",
  "metaBlock": "IAjEnG_metaBlock",
  "metaGrid": "IAjEnG_metaGrid",
  "metaLabel": "IAjEnG_metaLabel",
  "metaLeft": "IAjEnG_metaLeft",
  "metaOverview": "IAjEnG_metaOverview",
  "metaRight": "IAjEnG_metaRight",
  "metaSection": "IAjEnG_metaSection",
  "metaText": "IAjEnG_metaText",
  "metaTools": "IAjEnG_metaTools",
  "page": "IAjEnG_page",
  "specimenCaption": "IAjEnG_specimenCaption",
  "specimenFigure": "IAjEnG_specimenFigure",
  "specimenSvg": "IAjEnG_specimenSvg",
});
